const contact_info = (state = null, action: any) => {
	switch(action.type) {
		case 'SET_CONTACT_INFO':
            return action.payload;
            break;
        default: 
        	return state;
        	break;
	}
}

export default contact_info;